import { useRef } from 'react'

import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { IconOptionsReport, IconOptionsThrash, IconOptionsCopy,} from 'assets/svg/sprite'
import { useOutsideAlerter } from 'helpers/hooks'


interface ReelOptionsProps {
    isOpen: boolean
    setIsOpen: (setTo: boolean) => void
    handleDelete?: () => void
    handleReport?: () => void
    handleCopyLink?: () => void
    isOwner: boolean
    storyId: string
}

export function ReelOptions({
    isOpen,
    setIsOpen,
    handleDelete,
    handleReport,
    handleCopyLink,
    isOwner,
}: ReelOptionsProps) {
    const { t } = useTranslation()
    const optionsRef = useRef<HTMLDivElement>(null)

    useOutsideAlerter(optionsRef, () => {
        setIsOpen(false)
    })

    return (
        <OptionsWrapper $open={isOpen}>
          <div ref={optionsRef}>
            {isOwner ? (
              <OptionContainer onClick={handleDelete}>
                <IconOptionsThrash />
                <OptionSpan>{t('deleteStory')}</OptionSpan>
              </OptionContainer>
            ) : (
              <>      
{/*                 <OptionContainer onClick={handleCopyLink}>
                  <IconOptionsCopy />
                  <OptionSpan>{t('copyLinkToStory')}</OptionSpan>
                </OptionContainer>
                <div className={styles.separator}></div> */}
                <OptionContainer onClick={handleReport}>
                <IconOptionsReport />
                  <OptionSpan>{t('report')}</OptionSpan>
                </OptionContainer>

              </>
            )}
          </div>
        </OptionsWrapper>
      )
}

interface OptionsWrapperProps {
    $open: boolean
}

const OptionsWrapper = styled.div<OptionsWrapperProps>`
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: #ffffff;
    box-shadow: 0 -2rem 4rem rgba(17, 29, 41, 0.6);
    padding: 3rem 0 2rem;
    border-top-left-radius: 2rem;
    border-top-right-radius: 2rem;
    display: ${({ $open }) => ($open ? 'block' : 'none')};
    z-index: 9;
`

const OptionSpan = styled.span`
    color: #0d1444;
    font-family: Montserrat, sans-serif;
    font-size: 1.4rem;
    font-style: normal;
    font-weight: 600;
    letter-spacing: 0.02em;
    line-height: 1.7rem;
    margin-left: 1.4rem;
`

const OptionContainer = styled.div`
    padding: 1.3rem 3rem 0.8rem;
    align-items: center;
    display: flex;
    margin-bottom: 1rem;
    &:hover {
        background-color: #f4f4f4;
    }
`
